// src/pages/Admin/SystemHealthPage.tsx
import { Container, Box, Typography } from '@mui/material';
import SystemHealthView from '../../components/Dashboard/SystemHealthView';

export function SystemHealthPage() {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h4" component="h1" sx={{ color: 'white', mb: 3 }}>
        System Health
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        System monitoring and health indicators.
      </Typography>

      <Box sx={{ mb: 3 }}>
        <SystemHealthView />
      </Box>
    </Container>
  );
}
